import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { ProgressSpinner } from 'primereact/progressspinner';

import { CommonLayout, NavBar, headerNavigation } from '@marketplace/common';
import { AddEditApplicationModal } from '@developer/features';
import { useAPIFetchDevelopersApplications } from '@marketplace/api';
import { ROUTE_DEVELOPER_DASHBOARD_MY_PROFILE } from '@developer/constants';
import { Logo, Button } from '@marketplace/ui-elements';

import { AppList, NoApplications} from './components';
import { useHeaderMenu } from '../shared';

import classes from './main-page.module.scss';
import cn from 'classnames';
import { New_footer as SimpleFooter } from '../../pages/layouts/landing-layout/footer/footer';
import { PAGE, PER_PAGE } from '../constant';

const Title = ({ text }: { text: string }) => {
  return <span className={classes.title}>{text}</span>;
};

export const MainPage = () => {
  const { formatMessage } = useIntl();
  const rightHeaderSection = useHeaderMenu({
    profileUrl: ROUTE_DEVELOPER_DASHBOARD_MY_PROFILE,
    iconClassName: classes.menu_icon,
  });
  const [isOpenModal, setIsOpenModal] = useState(false);

  const openModal = () => setIsOpenModal(true);
  const closeModal = () => setIsOpenModal(false);

  const { data, loading, fetchDevelopersApplications , isUnknown, loaded} = useAPIFetchDevelopersApplications();
  const Banner = () => (
    <div>
      <p className={classes.bannerText}> <i className={cn('pi pi pi-info-circle', classes.icon)} /> {formatMessage({ id: 'developer_landing_header_Edit_User_And_Purpose_Info' })}</p>
    </div>
  );
  useEffect(() => {
    fetchDevelopersApplications({ per_page: PER_PAGE, page: PAGE });
  }, []);

  return (
    <div>
      <CommonLayout
        leftSection={<Title text={formatMessage({ id: 'developer_apps_count' }, { count: data?.total || 0 })} />}
        logo={<Logo subLogo={formatMessage({ id: 'developer_landing_header_sub_logo' })} />}
        rightSection={<Button onClick={openModal}>{formatMessage({ id: 'developer_add_app_button' })}</Button>}
        leftHeaderSection={<NavBar options={headerNavigation} />}
        rightHeaderSection={rightHeaderSection}
        banner={isUnknown && <Banner />}
      >
          {!!data?.items?.length && <AppList 
  appList={data.items} 
  fetchDevelopersApplications={fetchDevelopersApplications}
  totalRecords={data?.total}
  loading={loading}
  loaded={loaded}
/>
}
          {!data?.items?.length && loading && (
            <div className={classes.spinner_wrapper}>
              <ProgressSpinner />
            </div>
          )}
          {!data?.items?.length && !loading && <NoApplications />}
          {/* <Cards /> */}
          <AddEditApplicationModal id="AddEditApplicationModal" isOpen={isOpenModal} onReject={closeModal} />
      </CommonLayout>
      <div className={classes.registrationFooter}>
          <SimpleFooter/>
      </div>
    </div>
  );
};
